import React from "react";
import { Epg, Layout } from "planby";
import { useSelector } from "react-redux";

// Import hooks
import { useApp } from "./useApp";

// Import components
import { Timeline, ChannelItem, ProgramItem } from "./components";

function LiveEpgContainer() {
  const { isLoading, getEpgProps, getLayoutProps, channelLength } = useApp();
  return (
    <div>
      <div style={{ height: channelLength <= 9 ? "100vh" :"190vh", width: "100%" }}>
        <Epg isLoading={isLoading} {...getEpgProps()}>
          <Layout
            {...getLayoutProps()}
            renderTimeline={(props) => <Timeline {...props} />}
            renderProgram={({ program, ...rest }) => {
              return <ProgramItem key={program.data.id} program={program} {...rest} />
            }}
            renderChannel={({ channel }) =>
            {
              return <ChannelItem key={channel.uuid} channel={channel} />
            }
          }
          />
        </Epg>
      </div>
    </div>
  );
}

export default LiveEpgContainer;
